import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Settings {
  daemonUrl: string
  conclaveUrl: string
  assayUrl: string
  assayApiKey: string
  loreUrl: string
  gatewayUrl: string
  gateUrl: string
}

interface UIState extends Settings {
  sidebarOpen: boolean
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  updateSettings: (s: Partial<Settings>) => void
}

const defaults: Settings = {
  daemonUrl:   import.meta.env.VITE_DAEMON_URL    ?? 'http://localhost:8001',
  conclaveUrl: import.meta.env.VITE_CONCLAVE_URL  ?? 'http://localhost:8002',
  assayUrl:    import.meta.env.VITE_ASSAY_URL     ?? 'http://localhost:8000',
  assayApiKey: import.meta.env.VITE_ASSAY_API_KEY ?? '',
  loreUrl:     import.meta.env.VITE_LORE_URL      ?? 'http://localhost:8003',
  gatewayUrl:  import.meta.env.VITE_GATEWAY_URL   ?? 'http://localhost:8080',
  gateUrl:     import.meta.env.VITE_GATE_URL      ?? 'http://localhost:8004',
}

export const useUI = create<UIState>()(
  persist(
    (set) => ({
      ...defaults,
      sidebarOpen: true,
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      updateSettings: (s) => set(s),
    }),
    { name: 'apex-ui' },
  ),
)
